module.exports = __webpack_public_path__ + "static/img/zsk.a495112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zsk.png
// module id = 6yF5
// module chunks = 78